import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../components/context/CartContext';

export default function useCheckout() {
    const [startCheckout, setStartCheckout] = useState(false);
    const {
        checkoutData,
    } = useContext(CartContext);
    const navigate = useNavigate();
    const fetchWebUrl = useCallback(() => {
        if (checkoutData?.webUrl) {
            // eslint-disable-next-line no-undef
            window.location.assign(checkoutData.webUrl);
        } else {
            navigate('/cart');
        }
    }, [navigate, checkoutData]);
    useEffect(() => {
        if (startCheckout) {
            fetchWebUrl();
            setStartCheckout(false);
        }
    }, [fetchWebUrl, startCheckout]);
    return {
        startCheckout,
        setStartCheckout,
    };
}